import { useState } from "react";
import { Slider } from "components/ui/slider";
import { Calculator } from "lucide-react";

const CalculatorSection = () => {
  const [kg, setKg] = useState([1]);

  // Үнэ тооцоолох
  let totalPrice = 0;
  if (kg[0] <= 10) {
    totalPrice = kg[0] * 2500;
  } else {
    totalPrice = kg[0] * 2000;
  }

  return (
    <section id="calculator" className="py-20 bg-background w-full">
      <div className="container mx-auto px-4">
        {/* <div className="text-center mb-12 animate-fade-up">
          <h2 className="text-3xl font-bold text-foreground mb-3">Тооцоолуур</h2>
          <p className="text-muted-foreground">Хүргэлтийн үнээ тооцоолоорой</p>
        </div> */}

        <div className="max-w-lg mx-auto card-elevated p-8 animate-fade-up delay-200">
          <div className="flex items-center gap-3 mb-8">
            <Calculator className="w-8 h-8 text-primary" />
            <span className="text-xl font-semibold text-foreground">
              Жин оруулах
            </span>
          </div>

          <div className="space-y-8">
            <div>
              <div className="flex justify-between mb-3">
                <label className="text-sm font-medium text-foreground">
                  Жин:
                </label>
                <span className="text-sm font-bold text-primary">
                  {kg[0]} кг
                </span>
              </div>
              <Slider
                value={kg}
                onValueChange={setKg}
                max={50} // хамгийн их кг
                min={1}
                step={1}
                className="[&_[role=slider]]:bg-primary [&_[role=slider]]:border-primary [&_.range]:bg-primary"
              />
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-border text-center">
            <span className="text-lg text-muted-foreground">Нийт үнэ: </span>
            <span className="text-3xl font-extrabold text-primary">
              {totalPrice.toLocaleString()} ₮
            </span>
            <div className="mt-2 text-sm text-green-700">
              20кг-аас доош жинтэй бараа кг 2500₮
              <br /> 20кг-аас дээш жинтэй бараа кг 2000₮
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalculatorSection;
